<template>
    <div class="popup" :class="{ active: step == 1 }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>개인정보 수집 및 이용 동의</h2>
                    <button type="button" class="popup__close" @click="cancelAgree"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <h3 class="mt-none">개인정보 수집 및 이용 동의</h3>
                    <div class="text-box-scroll">
                        <p>
                            대리인예약 전 개인정보 수집·이용에 대한 내용을 반드시 확인해주세요.
                            <br><br>
                            1.개인정보 등의 수집·이용 목적:환자 본인을 대신하여 대리인이 외래진료 예약을 진행하기 위한 용도<br>
                            2.수집하려는 개인정보 항목:<br>
                            1)환자본인:이름, 주민등록번호, 휴대전화번호(본인 또는 보호자)<br>
                            2)대리인:이름, 휴대전화번호(본인), 이메일<br>
                            3.개인정보 등의 보유 및 이용 기간:의료법에 준함<br>
                            4.귀하는 본 개인 정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 동의하지 않을 시에는 대리인 예약 서비스를 받으실 수 없습니다.<br>
                        </p>
                    </div>
                    <div class="checkbox-wrap">
                        <label  >
                            <input type="checkbox" id="test01" v-model="confirmCheck1">
                            <span class="checkbox-btn"></span>
                            <p>개인정보 수집 및 이용에 동의합니다.</p>
                        </label>
                    </div>

                    <h3>고유식별정보 이용 동의</h3>
                    <div class="text-box-scroll">
                        <p>
                            {{'이대' + this.$store.getters.getHostNm}}은 의료법 시행령 제 42조의 2, 국민건강보험법 제 12조에 의거하여 진료예약 환자 확인을 위한 아래의 고유식별변호를 수집하고 있음을 고지합니다.
                        </p>
                    </div>
                    <div class="checkbox-wrap">
                        <label  >
                            <input type="checkbox" id="test02" v-model="confirmCheck2">
                            <span class="checkbox-btn"></span>
                            <p>고유식별정보 수집 및 이용에 동의합니다.</p>
                        </label>
                    </div>

                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="cancelAgree">취소</a>
                        <a href="javascript:;" class="main-button c-main" @click="confirmAgree">확인</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="popup" :class="{ active: step == 2 }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>개인정보확인</h2>
                    <button type="button" class="popup__close" @click="cancelAgree"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <h3 class="mt-none">대리인 정보</h3>
                    <ul class="table-box__list">
                        <li class="table-box__item item1">
                            <div class="table-box__head">이름</div>
                            <div class="table-box__desc">{{ myInfo.name }}</div>
                        </li>

                        <li class="table-box__item item1">
                            <div class="table-box__head">휴대전화번호</div>
                            <div class="table-box__desc">{{ myInfo.hpNo.substring(0,3) }}-{{ myInfo.hpNo.substring(3,7) }}-{{ myInfo.hpNo.substring(7,11) }}</div>
                        </li>
                        <li class="table-box__item item1">
                            <div class="table-box__head">이메일</div>
                            <div class="table-box__desc">{{ myInfo.email }}</div>
                        </li>
                    </ul>

                    <h3>환자 정보</h3>
                    <ul class="table-box__list">
                        <li class="table-box__item item1">
                            <div class="table-box__head">이름</div>
                            <div class="table-box__desc">{{ patInfo.patName }}</div>
                        </li>

                        <li class="table-box__item item1">
                            <div class="table-box__head">주민번호</div>
                            <div class="table-box__desc">{{ patInfo.patRrn.substring(0, 6) }}-{{ patInfo.patRrn.substring(6, 13) }}</div>
                        </li>
                        <li class="table-box__item item1">
                            <div class="table-box__head">휴대전화번호</div>
                            <div class="table-box__desc">{{ patInfo.patHpNo.substring(0, 3) }}-{{ patInfo.patHpNo.substring(3, 7) }}-{{ patInfo.patHpNo.substring(7, 11) }}</div>
                        </li>
                    </ul>

                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="cancelAgree">취소</a>
                        <a href="javascript:;" class="main-button c-main" @click="getPtno">확인</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            patInfo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                popupShow: false,
                confirmCheck1: false,
                confirmCheck2: false,
                step: 1,
                myInfo: this.$store.state.myInfoStore,
            }
        },
        mounted() {

        },
        methods: {
            cancelAgree() {
                this.step = 1

                this.$emit('cancelAgree')
            },
            confirmAgree() {
                if(!this.confirmCheck1 ){
                    alert('개인정보 수집 및 이용 동의가 필요합니다.'+this.confirmCheck1)
                    return
                }else if(!this.confirmCheck2){
                    alert('고유식별정보 수집 및 이용 동의가 필요합니다.')
                    return
                }
                this.step = 2
            },
            getPtno(){

                this.axios.get(this.api.appointment.getPatInfo, {
                    params: {
                        PT_NM: this.patInfo.patName,
                        RRN: this.patInfo.patRrn,
                        MTEL_NO: this.patInfo.patHpNo
                    }
                }).then(response => {
                    const data = response.data

                    this.$emit('confirmPopup', data)

                })
            }
        },
    }
</script>